import { type FunctionComponent } from 'react';
import { type VariationOptionFieldsFragment } from '../../../../../__generated__/graphql-client-types';
import { formatPrice } from '../../../../../helpers/general-helper/general-helper';
import { useNavigation } from '../../../../../hooks/navigation/navigation.hooks';
import { ClickableElement } from '../../../../buttons';
import { CloudinaryImage } from '../../../../images/cloudinary-image/cloudinary-image.component';
import CheckIcon from '../../../../svgs/check.svg';
import { pillMinHeight, pillWidth } from './variation-option-pill.css';

export type VariationOptionPillProps = {
	option: VariationOptionFieldsFragment;
	isDropdown?: boolean;
	showCheck?: boolean;
};

export const VariationOptionPill: FunctionComponent<VariationOptionPillProps> = ({ option, isDropdown = false, showCheck = false }) => {
	const navigate = useNavigation();
	const { name, url, price, image, isSelected } = option;
	const defaultClasses = `${isSelected ? 'b--theme-grey-darker' : 'b--theme-grey-light'} bw1 br2 b--solid ${pillWidth}`;
	const dropdownClasses = `b--theme-grey-light bw0`;

	return (
		<ClickableElement
			ariaLabel={`Select option ${name}`}
			className={`pa0 bg-transparent pointer w-100 flex justify-between items-center ba ${
				isDropdown ? dropdownClasses : defaultClasses
			}`}
			onClick={() => navigate(url || '')}
			testId="product-option-pill">
			<>
				<div className={`flex flex-row justify-start items-center w-100 w-auto-ns ph2 ${pillMinHeight}`}>
					{image && (
						<CloudinaryImage
							className="pr2"
							publicID={image.id}
							description={image.description}
							options={{ width: 55, height: 55 }}
						/>
					)}

					<div className="flex flex-column items-start justify-between">
						<div className="tc2-title tl f6">{name}</div>
						{price?.current ? (
							<div className="theme-grey f6" data-testid="product-option-price">
								{formatPrice(price.current)}
							</div>
						) : null}
					</div>
				</div>
				{isSelected && showCheck && <CheckIcon className="f4 theme-primary pl0 pt2 pb2 pr2" data-testid="CheckIcon" />}
			</>
		</ClickableElement>
	);
};
